import React, { useState, useEffect } from "react";
import Slider from "@mui/material/Slider";
import styled from "styled-components";
import { getPossibleValues } from "../../util/SliderUtil";

const SliderContainer = styled.div`
    height: 16px;
    width: calc(100% - 32px);
    display: flex;
    justify-content: center;
    align-items: center;
`;

function SingleValueSlider({ styleSetting, updateStyleSettings, sliderDisplayValue, setSliderDisplayValue }) {
    const { name, value } = styleSetting;
    const possibleValues = getPossibleValues(styleSetting);
    const initialNumberValue = possibleValues.indexOf(sliderDisplayValue || value) + 1;
    const [numberValue, setNumberValue] = useState(initialNumberValue);

    useEffect(() => {
        const newNumberValue = possibleValues.indexOf(value) + 1;
        // Sync only if sliderDisplayValue is undefined or invalid
        if (sliderDisplayValue === undefined || !possibleValues.includes(sliderDisplayValue)) {
            setNumberValue(newNumberValue);
            setSliderDisplayValue(value);
        } else if (possibleValues[numberValue - 1] !== sliderDisplayValue) {
            setNumberValue(possibleValues.indexOf(sliderDisplayValue) + 1);
        }
    }, [value, possibleValues, sliderDisplayValue, setSliderDisplayValue]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            const newValue = possibleValues[numberValue - 1];

            if (newValue !== value) {
                updateStyleSettings(name, newValue);
            }
        }, 200);

        return () => clearTimeout(timeout);
    }, [numberValue, name, possibleValues, updateStyleSettings, value]);

    const handleChange = (event, newNumberValue) => {
        setNumberValue(newNumberValue);
        const newDisplayValue = possibleValues[newNumberValue - 1];
        setSliderDisplayValue(newDisplayValue);
    };

    return (
        <SliderContainer key={possibleValues.length}>
            <Slider
                getAriaLabel={() => `${name} slider`}
                value={numberValue}
                size="small"
                onChange={handleChange}
                valueLabelDisplay="off"
                step={1}
                marks={possibleValues.length > 20 ? false : true}
                min={1}
                max={possibleValues.length}
            />
        </SliderContainer>
    );
}

export default SingleValueSlider;